export const openTimePickerDialog = (id) => {
    return {
        type: "OPEN_TIMEPICKER_DIALOG",
        payload: {id}
    };
};

export function closeTimePickerDialog() {
    return {
        type: "CLOSE_TIMEPICKER_DIALOG",
    };
}

export function cancelTimePickerDialog() {
    return {
        type: "CANCEL_TIMEPICKER_DIALOG",
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/timepick.js